import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  RaffleAdminConfig,
  RaffleTicketFlipDirection,
} from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { raffleTicketFlipDirection } from '../drawing/ticketMotion';

export function TicketFlipDirectionInput() {
  const { state, dispatch } = useAdminEngagementContext();
  const value = raffleTicketFlipDirection(
    state.config as RaffleAdminConfig | null,
  );

  return (
    <Select
      value={value}
      onValueChange={(next) => {
        dispatch(
          configChanged({
            config: {
              ticketFlipDirection: next as RaffleTicketFlipDirection,
            },
          }),
        );
      }}
    >
      <SelectTrigger data-name="RAFFLE_TICKET_FLIP_DIRECTION">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={RaffleTicketFlipDirection.AdmitToDrawing}>
          Admit → drawing
        </SelectItem>
        <SelectItem value={RaffleTicketFlipDirection.DrawingToAdmit}>
          Drawing → admit
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
